export default __webpack_public_path__ + "static/media/Ellipse.d464ff73.svg";